import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from 'src/app/services/Auth/auth.service';

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  if (req.headers.keys().includes('skip_session_interceptor')) {
    return next(
      req.clone({ headers: req.headers.delete('skip_session_interceptor') })
    );
  }
  return next(req).pipe(
    catchError((err) => {
      if (auth.isAuthenticated() && err.status == 401) {
        router.navigate(['/logout']);
      }
      return throwError(err);
    })
  );
};
